import styled from 'styled-components';

export const LoginCardContainer = styled.div`
    min-width: 320px;
    height: 101px;
    flex-shrink: 0;
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    background: linear-gradient(180deg, #fff 21.46%, #f7f7f7 100%);
    display: flex;
    flex-direction: row;
    padding: 12px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    position: relative;
    overflow: hidden;
    align-self: stretch;
    margin: 16px;
`;

export const LoginCardHeadingWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
    flex-shrink: 0;
    min-width: 0;
    z-index: 1;
    height: 100%;
`;

export const LoginCardHeadingText = styled.div`
    color: #121212;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    max-width: 218px;
`;

export const LoginCardImageWrapper = styled.div`
    width: 160px;
    height: 105px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 0;
    border-radius: 0 16px 16px 0;
`;

export const EllipsesContainer = styled.div`
    width: 160px;
    height: 105px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const EllipsesIconWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const LoginCardImageInner = styled.div`
    position: absolute;
    bottom: 0%;
    right: 10%;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 82px;
        height: 70px;
        display: block;
    }
`;

export const LoginButtonCtaWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    cursor: pointer;
`;

export const LoginButtonCtaText = styled.div`
    color: #1b73e8;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const LoginButtonCtaIcon = styled.div`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
`;
